import React from 'react'
import Filtro from '../comum/Filtro'
import PainelFiltragem from '../comum/PainelFiltragem'
import FiltrosAdicionadosInteressadosPromocao from './FiltrosAdicionadosInteressadosPromocao';
import FiltroInteressadosPromocao from './FiltroInteressadosPromocao';

export const PainelFiltroInteressados = () => (
  <Filtro PainelFiltro={FiltroInteressadosPromocao}/>
);

const PainelFiltrosInteressados = () => (
  <PainelFiltragem
    Filtro={PainelFiltroInteressados}
    FiltrosAdicionados={FiltrosAdicionadosInteressadosPromocao}/>
)

export default PainelFiltrosInteressados
